import { render, staticRenderFns } from "./SwapSessionPage.vue?vue&type=template&id=260e7704&scoped=true&lang=pug"
import script from "./SwapSessionPage.vue?vue&type=script&lang=js"
export * from "./SwapSessionPage.vue?vue&type=script&lang=js"
import style0 from "./SwapSessionPage.vue?vue&type=style&index=0&id=260e7704&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260e7704",
  null
  
)

export default component.exports